// Components==============
import { faSignOut, faUser } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import signOut from 'actions/authentication/logout';
import Container from 'components/UI/Container';
import LoginModal from 'components/UI/LoginModal/LoginModal';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMediaQ } from 'utilities/useMediaQ';
import Logo from './components/Logo';
import MobileMenu from './components/MobileMenu';
import NavItems from './components/NavItems/NavItems';
import './index.module.scss';

// =========================

export default function Nav({ color = 'purple' }) {
    const [loginModalIsOpen, setLoginModalIsOpen] = useState(false);
    const query = useMediaQ('min', 840);

    const isAuthenticated = useSelector(
        (state) => state.authentication.isLoggedIn
    );

    const dispatch = useDispatch();
    const headerColor = `${color}-header`;

    return (
        <>
            <Container color={headerColor}>
                <div styleName="grid">
                    <Logo />
                    {query && (
                        <>
                            <div styleName="navItems">
                                <NavItems
                                    setLoginModalIsOpen={setLoginModalIsOpen}
                                />
                            </div>

                            {isAuthenticated ? (
                                <div
                                    onClick={() => dispatch(signOut())}
                                    styleName="sign-out"
                                >
                                    <FontAwesomeIcon icon={faSignOut} />
                                </div>
                            ) : (
                                <div
                                    onClick={() => setLoginModalIsOpen(true)}
                                    styleName="sign-out"
                                >
                                    <FontAwesomeIcon icon={faUser} />
                                </div>
                            )}
                        </>
                    )}
                    {!query && (
                        <div styleName="mobileMenu">
                            <MobileMenu
                                setLoginModalIsOpen={setLoginModalIsOpen}
                            />
                        </div>
                    )}
                </div>
            </Container>
            {!!loginModalIsOpen && (
                <LoginModal setModalIsOpen={setLoginModalIsOpen} />
            )}
        </>
    );
}
